<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Policy Type</span>
        <span>{{ getAllOptionName23('plan_type', quoteForm.plan_type) }}</span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span>{{ getAllOptionName23('area_of_travel', quoteForm.area_of_travel) }}</span>
      </div>
      <div class="tr">
        <span>Departure and Return Date</span>
        <span>{{ quoteForm.pcy_cmnt_dt }} - {{quoteForm.pcy_expry_dt}}</span>
      </div>

    </div>
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Cover Type</span>
        <span>{{ getAllOptionName23('class_type', quoteForm.class_type) }}</span>
      </div>

      <div
        v-if="quoteForm.class_type==1&&![1,3,4].includes(quoteForm.plan_type)"
        class="tr">
        <span>No. of Traveller(s)</span>
        <span>{{ getAllOptionName23('traveler_num', quoteForm.no_of_traveler) }}</span>
      </div>
      <div
        v-if="quoteForm.class_type!==1||[1,3,4].includes(quoteForm.plan_type)"
        class="tr">
        <span>No. of Traveller(s)</span>
        <span>{{traveller}}</span>
      </div>

    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'TravelQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    traveller(){
      const { class_type, no_of_traveler, no_of_adult, no_of_child, plan_type,no_of_senior } = this.quoteForm
      const sign = 'Persons'
      const signAdult = 'Adult(s)'
      const signSenior = 'Elderly'
      const signChild = 'Child(ren)'
      let child = no_of_child?`${no_of_adult>0?'·':''} ${no_of_child} ${signChild}`:''
      let senior = no_of_senior?`${no_of_senior} ${signSenior} ${no_of_adult||no_of_child?' ·':''} `:''
      let adult = no_of_adult?`${no_of_adult} ${signAdult} `:''
      let all_text = `${senior} ${adult} ${child}`
      return all_text
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
        width: calc(50% - 10px);
    }
}
</style>
